import { render, staticRenderFns } from "./BpcTableOrders.vue?vue&type=template&id=2b11c117&"
import script from "./BpcTableOrders.vue?vue&type=script&lang=js&"
export * from "./BpcTableOrders.vue?vue&type=script&lang=js&"
import style0 from "./BpcTableOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports